import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const API_URL = `${liveURL}/faq`;

export async function getFAQs() {
  try {
    const response = await axios.get(API_URL, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}
